import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';

const stripNodes = (obj) => {
  if (isArray(obj)) {
    return obj.map(el => stripNodes(el));
  }
  if (!isPlainObject(obj)) {
    return obj;
  }
  const result = {};
  Object.keys(obj).forEach(key => {
    if (!key.startsWith('__')) {
      result[key] = stripNodes(obj[key]);
    }
  });
  return result;
};

export const formatResponse = (response) => {
  const data = stripNodes(response.data[Object.keys(response.data)[0]]);
  if (data.meta && data.meta.pagination) {
    context.store.commit('utils/setPagination', data.meta.pagination);
  }
  delete data.meta;
  return data;
};

export const i18nScope = (route, $i18n) => {
  let path = route.path.split('/').filter(el => el);
  if ($i18n.locales.find(locale => locale.code === path[0])) {
    path.shift();
  }
  return path.join('.');
};

export const metaKey = (route, key) => {
  const meta = route.meta && route.meta.find(m => m[key]);
  return meta ? meta[key] : null;
};

export const scrollToTop = () => {
  let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  let scrollToOptions = {
    top: 0,
    left: 0,
    behavior: 'smooth'
  };
  isSmoothScrollSupported ? window.scroll(scrollToOptions) : window.scroll(scrollToOptions.left, scrollToOptions.top);
};

export const productToCookie = (product) => {
  return {
    institution: product.institution ? product.institution.name : '',
    plan: product.name,
    link: product.url ? product.url.link : ''
  };
};

export const formatCustomer = (customer) => {

};

export const getProductFromPath = (path) => {
  let product = '';
  if (path.includes('blog')) {
    product = 'blog';
  } else if (path.includes('guides')) {
    product = 'guides';
  } else if (path.includes('home-movers')) {
    product = 'mortgages';
  } else if (path.includes('podcasts')) {
    product = 'podcasts';
  } else if (path.includes('savings')) {
    product = 'savings-accounts';
  } else if (path.includes('current')) {
    product = 'current-accounts';
  } else {
    // cuts off the /compare- and takes the first part of the string (eg just 'home-insurance' and not 'home-insurance/about-you/')
    product = path.slice(9).split('/')[0];
  }

  return product;
};

export const localeBoolean = (value) => {
  return value ? 'yes' : 'no';
};

export const HOME_PHONE_CONSTRAINTS = () => {
  let constraints = {};

  constraints.pattern = String.raw`0\d{1,4}\d{7,8}`;
  constraints.title = 'Include your county code. Example: 012345678';
  constraints.minlength = 8;
  constraints.maxlength = 15;

  return constraints;
};
